import type { OccurrenceAmenityClash } from "@/types/OccurrenceAmenities";

const formatKey = (key: string) =>
  new Date(`${key}T00:00:00.000Z`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });

/** R27 — names every clashing amenity/date so staff can pick around them. */
export const OccurrenceAmenityClashList = ({ clashes }: { clashes: OccurrenceAmenityClash[] }) => {
  if (clashes.length === 0) return null;
  return (
    <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800" data-testid="occurrence-amenity-clashes">
      <p className="font-medium">Nothing was saved — these are already booked:</p>
      <ul className="mt-1 list-disc pl-5">
        {clashes.map((c) => (
          <li key={`${c.amenityId}-${c.date}`}>
            {[c.amenityName, formatKey(c.date), c.memberName].filter(Boolean).join(" — ")}
          </li>
        ))}
      </ul>
    </div>
  );
};
